import React from 'react';

const  SocialIcons = () => {
 
   return (
        <div className="dz-social-icon">
            <ul>
               
 
                <li>
                    <a target="_blank" className="text-dark" href="https://www.youtube.com/@anuughacollections" rel="noreferrer">
                        <i className="fa-brands fa-youtube"></i>
                    </a>
                </li>
 
                <li>
                    <a target="_blank" className="text-dark" href="https://www.instagram.com/anuughacollections" rel="noreferrer">
                        <i className="fab fa-instagram"></i>
                    </a>
                </li>
                <li>
                    <a target="_blank" className="text-dark" href="https://www.facebook.com/anuughacollections" rel="noreferrer">
                        <i className="fab fa-facebook-f"></i>
                    </a>
                </li>
            </ul>
        </div>
  );
}

export default SocialIcons;
 